import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit3-introduction',
  templateUrl: './unit3-introduction.component.html',
  styleUrls: ['./unit3-introduction.component.css']
})
export class Unit3IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
